export default "__VITE_ASSET__BQ5u2iPz__"